module.exports = __webpack_public_path__ + "static/media/How-does-it-works.81c80a7a.mp4";